<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="11">
        <span style="font-size:18px;"
          >{{ $l('title_category') || '产品分类' }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: { keyword: '' } 
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
